(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lilis-about"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lilis-instagram')) {
    class LilisInstagram extends HTMLElement {
      static loader = null;

      static loadLibrary() {
        if (window.instgrm && window.instgrm.Embeds) {
          return Promise.resolve();
        }

        if (LilisInstagram.loader) {
          return LilisInstagram.loader;
        }

        LilisInstagram.loader = new Promise((resolve, reject) => {
          let script = document.querySelector(
            'script[src="https://www.instagram.com/embed.js"]'
          );

          let owned = false;

          const finish = (error) => {
            clearTimeout(timer);
            script.removeEventListener('load', onLoad);
            script.removeEventListener('error', onError);

            if (error) {
              if (owned) {
                script.remove();
              }

              reject(error);
            } else {
              resolve();
            }
          };

          const onLoad = () => {
            const error =
              window.instgrm && window.instgrm.Embeds
                ? null
                : new Error('embed-unavailable');

            finish(error);
          };

          const onError = () => {
            finish(new Error('embed-unavailable'));
          };

          if (!script) {
            owned = true;
            script = document.createElement('script');
            script.src = 'https://www.instagram.com/embed.js';
            script.async = true;
          }

          const timer = setTimeout(onError, 12000);

          script.addEventListener('load', onLoad, { once: true });
          script.addEventListener('error', onError, { once: true });

          if (owned) {
            document.head.appendChild(script);
          }
        }).catch((error) => {
          LilisInstagram.loader = null;
          throw error;
        });

        return LilisInstagram.loader;
      }

      connectedCallback() {
        this.button = this.querySelector('[data-instagram-load]');
        this.slot = this.querySelector('[data-instagram-slot]');
        this.status = this.querySelector('[data-instagram-status]');

        if (!this.button || !this.slot || !this.status) {
          return;
        }

        if (this.onClick) {
          this.button.removeEventListener('click', this.onClick);
        }

        try {
          const url = new URL(this.dataset.url);
          const match = url.pathname.match(
            /^\/(p|reel)\/([A-Za-z0-9_-]+)\/?$/
          );

          if (
            url.protocol !== 'https:' ||
            !['instagram.com', 'www.instagram.com'].includes(url.hostname) ||
            url.port ||
            !match
          ) {
            return;
          }

          this.permalink =
            'https://www.instagram.com/' +
            match[1] +
            '/' +
            match[2] +
            '/';
        } catch (_) {
          return;
        }

        this.button.hidden = false;
        this.onClick = () => this.loadPost();
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.button && this.onClick) {
          this.button.removeEventListener('click', this.onClick);
        }
      }

      async loadPost() {
        this.button.disabled = true;
        this.status.textContent = this.dataset.loading;

        const quote = document.createElement('blockquote');
        quote.className = 'instagram-media';
        quote.dataset.instgrmPermalink = this.permalink;
        quote.dataset.instgrmVersion = '14';

        const link = document.createElement('a');
        link.href = this.permalink;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = 'Instagram';

        quote.appendChild(link);
        this.slot.replaceChildren(quote);

        try {
          await LilisInstagram.loadLibrary();

          if (!this.isConnected) {
            return;
          }

          window.instgrm.Embeds.process();
          this.status.textContent = '';
          this.button.hidden = true;
          this.slot.focus({ preventScroll: true });
        } catch (_) {
          if (!this.isConnected) {
            return;
          }

          this.status.textContent = this.dataset.error;
          this.slot.replaceChildren();
          this.button.disabled = false;
        }
      }
    }

    customElements.define('lilis-instagram', LilisInstagram);
  }

  (() => {
    if (!('IntersectionObserver' in window)) {
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (
            entry.isIntersecting &&
            entry.intersectionRatio >= 0.35
          ) {
            video.muted = true;
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: [0, 0.35]
      }
    );

    document
      .querySelectorAll('.lw-about__video--autoplay')
      .forEach((video) => observer.observe(video));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
